import * as PropTypes from 'prop-types';
import { ptColor } from '../../consts/propTypes.const';
export var spinnerDisplayName = 'spinner';
export var spinnerDefaultProps = {
  color: 'lightOrange',
  'data-id': spinnerDisplayName,
  size: 'sm',
  show: true
};
export var spinnerPropTypes = {
  color: ptColor,
  'data-id': PropTypes.string,
  show: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};